<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-success">
          <div class="panel-heading">
            <h3 class="panel-title">Dados Abertos - Admin</h3>
          </div>
          <div class="panel-body">
            <form role="form" @submit.prevent="login">
              <fieldset>
                <!-- input para SSHD -->
                <div class="form-group">
                  <input
                    :class="[
                      'form-control',
                      { 'is-danger': errors.has('username') }
                    ]"
                    v-model="model.username"
                    v-validate="'required'"
                    ref="username"
                    name="username"
                    type="text"
                    placeholder="Usuário"
                  />
                  <span v-show="errors.has('username')" class="is-danger">
                    <i class="fa fa-warning"></i>
                    O campo usuário é obrigatório
                  </span>
                </div>
                <div class="form-group">
                  <input
                    :class="[
                      'form-control',
                      { 'is-danger': errors.has('password') }
                    ]"
                    v-model="model.password"
                    v-validate="'required'"
                    ref="password"
                    placeholder="Senha"
                    name="password"
                    type="password"
                  />
                  <span v-show="errors.has('password')" class="is-danger">
                    <i class="fa fa-warning"></i>
                    O campo senha é obrigatório
                  </span>
                </div>
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="usuarioExterno"
                      ref="usuarioExterno"
                      v-model="model.usuarioExterno"
                    />Usuário externo
                  </label>
                </div>
                <!-- Change this to a button or input when using this as a form -->
                <button
                  class="btn btn-default btn-block"
                  style="margin-bottom:10px"
                  type="submit"
                  :disabled="requestPendente"
                >
                  Acessar
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      model: {
        username: '',
        password: '',
        usuarioExterno: false,
      },
      requestPendente: false
    }
  },
  mounted() {
    var params = this.$route.params
    
    if (params.errorMsg) {
      this.$toastr.e(params.errorMsg)
      this.$refs.username.focus()
    }
    if (params.user) {
      this.model.username = params.user
      this.$refs.password.focus()
    }

    if (!params.errorMsg && !params.hasOwnProperty('user')) {
      this.$refs.username.focus()
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        this.requestPendente = true
        if (!result) {
          this.requestPendente = false
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e('Verifique os campos obrigatórios')
          return
        }
        this.$store.dispatch('tryLogin', this.model)
        .then(response => {
          this.requestPendente = false
          this.$toastr.s('Login efetuado com sucesso.')
          this.$router.push('/admin')
        })
        .catch(({ data }) => {
          this.requestPendente = false
          this.errorMsg = Array.isArray(data) ? data[0] : data
          this.model.password = ''
          this.$toastr.e(this.errorMsg)
          this.$refs.password.focus()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue